import React from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import StationLogin from "./StationLogin";
import AdminLogin from "./AdminLogin";

/**
 * Smart Login Router:
 * Automatically resolves to the dedicated Station Studio Console login
 * when accessed via riya.console.tv.nanbateam.com (or /client/login, /station),
 * or the dedicated Super Admin Command Center login when on admin.tv.nanbateam.com.
 */
const Login = ({ portal }) => {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const portalParam = portal || searchParams.get('portal');
    const isClientRoute = 
        portalParam === 'client' || 
        location.pathname.includes('/client') || 
        location.pathname.includes('/station');

    const isConsoleHost = typeof window !== 'undefined' && (
        window.location.hostname.includes('console') ||
        window.location.hostname.includes('station')
    );

    if (portalParam === 'admin') {
        return <AdminLogin />;
    }

    if (isClientRoute || isConsoleHost) {
        return <StationLogin />;
    }

    return <AdminLogin />;
};

export { StationLogin, AdminLogin };
export default Login;
